import { render } from "./BeneficiariosComponent.vue?vue&type=template&id=4221a938&scoped=true"
import script from "./BeneficiariosComponent.vue?vue&type=script&lang=js"
export * from "./BeneficiariosComponent.vue?vue&type=script&lang=js"

import "./BeneficiariosComponent.vue?vue&type=style&index=0&id=4221a938&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4221a938"]])

export default __exports__